"use strict";
    !(function(t) {
      var i,
        n;
      (i =(function() {
        function i(i, n) {
          var o;
          (this.options = n),
          (this.$element = t(i)),
          (this.didInit =! 1),
          (o = this),
          this.$element.on("click.slickLightbox", this.options.itemSelector, function(i) {
            var n,
              e;
            if ((i.preventDefault(), (n = t(this)), n.blur(), "function" != typeof o.options.shouldOpen || o.options.shouldOpen(o, n, i))) 
              return((e = o.$element.find(o.options.itemSelector)), o.elementIsSlick() && ((e = o.filterOutSlickClones(e)), (n = o.handlePossibleCloneClick(n, e))), o.init(e.index(n)));
            
          });
        }
        return((i.prototype.init = function(t) {
          return((this.didInit =! 0), this.detectIE(), this.createModal(), this.bindEvents(), this.initSlick(t), this.open());
        }), (i.prototype.createModalItems = function() {
          var i,
            n,
            o,
            e,
            s,
            l;
          return(
            (e = this.options.lazyPlaceholder || "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"),
            (o = function(t, i, n) {
              return('<div class="slick-lightbox-slick-item">\n  <div class="slick-lightbox-slick-item-inner">\n    <img class="slick-lightbox-slick-img" ' + (
                !0 === n
                  ? ' data-lazy="' + t + '" src="' + e + '" '
                  : ' src="' + t + '" '
              ) + " />\n    " + i + "\n  </div>\n</div>");
            }),
            this.options.images
              ? (l = t.map(this.options.images, (function(t) {
                return function(i) {
                  return o(i, t.options.lazy);
                };
              })(this)))
              : ((i = this.filterOutSlickClones(this.$element.find(this.options.itemSelector))), (s = i.length), (n =(function(t) {
                return function(i, n) {
                  var e,
                    l,
                    r;
                  return((l =
                    { index: n,
                    length: s
                  }), (e = t.getElementCaption(i, l)), (r = t.getElementSrc(i)), o(r, e, t.options.lazy));
                };
              })(this)), (l = t.map(i, n))),
            l
          );
        }), (i.prototype.createModal = function() {
          var i,
            n;
          return((n = this.createModalItems()), (i = '<div class="slick-lightbox slick-lightbox-hide-init' + (
            this.isIE
              ? " slick-lightbox-ie"
              : ""
          ) + '" style="background: ' + this.options.background + ';">\n  <div class="slick-lightbox-inner">\n    <div class="slick-lightbox-slick slick-caption-' + this.options.captionPosition + '">' + n.join("") + "</div>\n  <div>\n<div>"), (this.$modalElement = t(i)), (this.$parts =
            {}), (this.$parts.closeButton = t(this.options.layouts.closeButton)), this.$modalElement.find(".slick-lightbox-inner").append(this.$parts.closeButton), t("body").append(this.$modalElement));
        }), (i.prototype.initSlick = function(i) {
          var n;
          return(
            (n =
              { initialSlide: i
            }),
            this.options.lazy && (n.lazyLoad = "ondemand"),
            null != this.options.slick
              ? "function" == typeof this.options.slick
                ? (this.slick = this.options.slick(this.$modalElement))
                : (this.slick = this.$modalElement.find(".slick-lightbox-slick").slick(t.extend({}, this.options.slick, n)))
              : (this.slick = this.$modalElement.find(".slick-lightbox-slick").slick(n)),
            this.$modalElement.trigger("init.slickLightbox")
          );
        }), (i.prototype.open = function() {
          return(this.options.useHistoryApi && this.writeHistory(), this.$element.trigger("show.slickLightbox"), setTimeout((function(t) {
            return function() {
              return t.$element.trigger("shown.slickLightbox");
            };
          })(this), this.getTransitionDuration()), this.$modalElement.removeClass("slick-lightbox-hide-init"));
        }), (i.prototype.close = function() {
          return(this.$element.trigger("hide.slickLightbox"), setTimeout((function(t) {
            return function() {
              return t.$element.trigger("hidden.slickLightbox");
            };
          })(this), this.getTransitionDuration()), this.$modalElement.addClass("slick-lightbox-hide"), this.destroy());
        }), (i.prototype.bindEvents = function() {
          var i;
          if (((i =(function(t) {
            return function() {
              var i;
              return((i = t.$modalElement.find(".slick-lightbox-inner").height()), t.$modalElement.find(".slick-lightbox-slick-item").height(i), t.$modalElement.find(".slick-lightbox-slick-img, .slick-lightbox-slick-item-inner").css("max-height", Math.round(t.options.imageMaxHeight * i)));
            };
          })(this)), t(window).on("orientationchange.slickLightbox resize.slickLightbox", i), this.options.useHistoryApi && t(window).on("popstate.slickLightbox", (function(t) {
            return function() {
              return t.close();
            };
          })(this)), this.$modalElement.on("init.slickLightbox", i), this.$modalElement.on("destroy.slickLightbox", (function(t) {
            return function() {
              return t.destroy();
            };
          })(this)), this.$element.on("destroy.slickLightbox", (function(t) {
            return function() {
              return t.destroy(!0);
            };
          })(this)), this.$parts.closeButton.on("click.slickLightbox touchstart.slickLightbox", (function(t) {
            return function(i) {
              return i.preventDefault(),
              t.close();
            };
          })(this)), (this.options.closeOnEscape || this.options.navigateByKeyboard) && t(document).on("keydown.slickLightbox", (function(t) {
            return function(i) {
              var n;
              if (((
                n = i.keyCode
                  ? i.keyCode
                  : i.which
              ), t.options.navigateByKeyboard && (
                37 === n
                  ? t.slideSlick("left")
                  : 39 === n && t.slideSlick("right")
              ), t.options.closeOnEscape && 27 === n)) 
                return t.close();
              
            };
          })(this)), this.options.closeOnBackdropClick)) 
            return(this.$modalElement.on("click.slickLightbox touchstart.slickLightbox", ".slick-lightbox-slick-img", function(t) {
              return t.stopPropagation();
            }), this.$modalElement.on("click.slickLightbox", ".slick-lightbox-slick-item", (function(t) {
              return function(i) {
                return i.preventDefault(),
                t.close();
              };
            })(this)));
          
        }), (i.prototype.slideSlick = function(t) {
          return "left" === t
            ? this.slick.slick("slickPrev")
            : this.slick.slick("slickNext");
        }), (i.prototype.detectIE = function() {
          if (((this.isIE =! 1), /MSIE (\d+\.\d+);/.test(navigator.userAgent) && new Number(RegExp.$1) < 9)) 
            return(this.isIE = !0);
          
        }), (i.prototype.getElementCaption = function(i, n) {
          return this.options.caption
            ? '<span class="slick-lightbox-slick-caption">' + function() {
              switch (typeof this.options.caption) {
                case "function":
                  return this.options.caption(i, n);
                case "string":
                  return t(i).data(this.options.caption);
              }
            }.call(this) + "</span>"
            : "";
        }), (i.prototype.getElementSrc = function(i) {
          switch (typeof this.options.src) {
            case "function":
              return this.options.src(i);
            case "string":
              return t(i).attr(this.options.src);
            default:
              return i.href;
          }
        }), (i.prototype.unbindEvents = function() {
          return(t(window).off(".slickLightbox"), t(document).off(".slickLightbox"), this.$modalElement.off(".slickLightbox"));
        }), (i.prototype.destroy = function(t) {
          if ((null == t && (t =! 1), this.didInit && (this.unbindEvents(), setTimeout((function(t) {
            return function() {
              return t.$modalElement.remove();
            };
          })(this), this.options.destroyTimeout)), t)) 
            return(this.$element.off(".slickLightbox"), this.$element.off(".slickLightbox", this.options.itemSelector));
          
        }), (i.prototype.destroyPrevious = function() {
          return t("body").children(".slick-lightbox").trigger("destroy.slickLightbox");
        }), (i.prototype.getTransitionDuration = function() {
          var t;
          return this.transitionDuration
            ? this.transitionDuration
            : ((t = this.$modalElement.css("transition-duration")), (
              this.transitionDuration = void 0 === t
                ? 500
                : t.indexOf("ms") > -1
                  ? parseFloat(t)
                  : 1e3 * parseFloat(t)
            ));
        }), (i.prototype.writeHistory = function() {
          return "undefined" != typeof history && null !== history && "function" == typeof history.pushState
            ? history.pushState(null, null, "")
            : void 0;
        }), (i.prototype.filterOutSlickClones = function(i) {
          return this.elementIsSlick()
            ? (i = i.filter(function() {
              var i;
              return((i = t(this)), ! i.hasClass("slick-cloned") && 0 === i.parents(".slick-cloned").length);
            }))
            : i;
        }), (i.prototype.handlePossibleCloneClick = function(i, n) {
          var o;
          return this.elementIsSlick() && i.closest(".slick-slide").hasClass("slick-cloned")
            ? ((o = i.attr("href")), n.filter(function() {
              return t(this).attr("href") === o;
            }).first())
            : i;
        }), (i.prototype.elementIsSlick = function() {
          return this.$element.hasClass("slick-slider");
        }), i);
      })()),
      (n =
        {
        background: "rgba(0,0,0,.8)",
        closeOnEscape: !0,
        closeOnBackdropClick: !0,
        destroyTimeout: 500,
        itemSelector: "a",
        navigateByKeyboard: !0,
        src: !1,
        caption: !1,
        captionPosition: "dynamic",
        images: !1,
        slick: {},
        useHistoryApi: !1,
        layouts: {
          closeButton: '<button type="button" class="slick-lightbox-close"></button>'
        },
        shouldOpen: null,
        imageMaxHeight: 0.9,
        lazy: !1
      }),
      (t.fn.slickLightbox = function(o) {
        return((o = t.extend({}, n, o)), t(this).each(function() {
          return(this.slickLightbox = new i(this, o));
        }), this);
      }),
      (t.fn.unslickLightbox = function() {
        return t(this).trigger("destroy.slickLightbox").each(function() {
          return(this.slickLightbox = null);
        });
      });
    })(jQuery);

    // # sourceMappingURL=slick-lightbox.min.js.map

    function fullPage(selector, anchors) {

      if ($("html").hasClass("fp-enabled")) 
        return;
      

      if (!$(".page-holder").hasClass(selector)) 
        return;
      

      console.log(selector)
      console.log($(".menu-" + selector).find("#fullpageMenu"))
      console.log(anchors)

      var fpAnchors = new Array();
      anchors.forEach(function(anchor, index) {
        fpAnchors.push(anchor[0]);
        console.log('anchor[0]', anchor[0])
        $(".menu-" + selector).find("#fullpageMenu").append('<li class="' + (
          index === 0
            ? "active"
            : ""
        ) + '" data-menuanchor="' + anchor[0] + '"><a href="#' + anchor[0] + '">' + anchors[index][1] + "</a></li>");
      });

      var to;

      if ($(window).width() <= 768) {
        $("." + selector).fullpage({
          menu: "#fullpageMenu",
          sectionSelector: ".inner-section",
          anchors: fpAnchors,
          afterLoad: function(anchorLink, index) {
            to = setTimeout(function() {
              $(".fullpageMenuContainer, .top-info").addClass("hidden");
            }, 1750);
          },
          onLeave: function(origin, destination, direction) {
            clearTimeout(to);
            $(".fullpageMenuContainer, .top-info").removeClass("hidden").removeClass("open");
            $(".inner-section").eq(destination - 1).find(".has-animate").addClass("animate");
          }
        });
      } else {
        $("." + selector).fullpage({
          menu: "#fullpageMenu",
          sectionSelector: ".inner-section",
          normalScrollElements: ".scrollable-content",
          anchors: fpAnchors,
          afterLoad: function(anchorLink, index) {
            to = setTimeout(function() {
              $(".fullpageMenuContainer").addClass("hidden");

              if (index > 1) 
                $(".top-info").addClass("hidden");
              
            }, 1750);
          },
          onLeave: function(origin, destination, direction) {
            clearTimeout(to);
            $(".fullpageMenuContainer, .top-info").removeClass("hidden").removeClass("open");
            $(".inner-section").eq(destination - 1).find(".has-animate").addClass("animate");
          }
        });
      }
    }

    $(".fullpageMenuContainerToggler, .top-info-toggler").click(function() {
      $(this).parent().toggleClass("open");
    });

    $(".btn-scroll-down-fp").click(function() {
      $.fn.fullpage.moveTo(2, 1);
    });

    $(".btn-scroll-last-fp").click(function() {
      $.fn.fullpage.moveTo($(".fp-section").length, 1);
    });

    $(document).on("click", function(e) {
      if (!$("body").hasClass("template-index")) 
        return;
      

      if (!$(e.target).closest(".grower-logo").length && !$(e.target).closest(".growers-gallery").length && !$(e.target).closest(".slick-lightbox").length) {
        $(".growers-logos .grower-logo .data").empty();
        $(".growers-logos .grower-logo").removeClass("show-data");

        $(".growers-logos .grower-logo").removeClass("active");

        $(".growers-gallery").slideUp(function() {
          $(this).slick("slickUnfilter");
        });

        $(".grower-logo").removeClass("active");
        $(".grower-logo").removeClass("show-data");
      }
    });

    $(".bottom-bar .collapse").click(function() {
      $(this).find("svg").toggleClass("open");
      $(this)
        .parent()
        .parent()
        .parent()
        .toggleClass("open");
      $(this)
        .parent()
        .parent()
        .parent()
        .find(".bottom-bar-info-wrapper-collapse-inner")
        .toggleClass("open");

      if ($(this)
          .parent()
          .parent()
          .parent()
          .find(".bottom-bar-info-wrapper-collapse-inner")
            .hasClass("protection-info")) 
        $(this)
          .parent()
          .parent()
          .parent()
          .find(".bottom-bar-info-wrapper-collapse-inner")
          .toggleClass("animate");
      
    });

    $(".top-info .button").click(function(e) {
      e.preventDefault();
      window.location.href = $(this).attr("href") + location.hash;
    });

    $(".ppfd-maps-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      infinite: true,
      prevArrow: $(".prev-ppfd"),
      nextArrow: $(".next-ppfd")
    });

    $(".bottom-bar-wrapper-slider:not(.enabled-desktop)").each(function() {
      var slickInduvidual = $(this);
      slickInduvidual.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        dots: false,
        infinite: false,
        rows: 0,
        prevArrow: slickInduvidual.parent().find(".prev"),
        nextArrow: slickInduvidual.parent().find(".next"),
        responsive: [
          {
            breakpoint: 768,
            settings: "unslick"
          }
        ]
      });
    });

    $(window).load(function() {
      if ($(window).width() >= 1200) 
        $(".form-slider").css("margin-right", $(".form-wrapper").outerWidth() + "px");
       else 
        $(".form-slider").css("margin-right", 0);
      
    });

    $(window).on("resize orientationChange", function() {
      if ($(window).width() <= 768) {
        $(".bottom-bar-wrapper-slider:not(.enabled-desktop)").slick("reinit");
        $(".form-slider").css("margin-right", 0);
      } else if ($(window).width() >= 1200) {
        $(".form-slider").css("margin-right", $(".form-wrapper").outerWidth() + "px");
      } else 
        $(".form-slider").css("margin-right", 0);
      
    });

    $(".bottom-bar-wrapper-slider.enabled-desktop").each(function() {
      var slickInduvidual = $(this);

      slickInduvidual.on("beforeChange", function(event, slick, currentSlide, nextSlide) {
        if ($(window).width() < 1800) 
          $(".cc-slider").slick("goTo", nextSlide);
         else {
          if ((currentSlide > nextSlide && (nextSlide !== 0 || currentSlide === 1)) || (currentSlide === 0 && nextSlide === slick.slideCount - 1)) 
            $(".cc-slider").slick("goTo", $(".cc-slider .slick-current").prev().attr("data-slick-index"));
           else 
            $(".cc-slider").slick("goTo", $(".cc-slider .slick-current").next().attr("data-slick-index"));
          
        }
      });

      slickInduvidual.slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: true,
        rows: 0,
        prevArrow: slickInduvidual.parent().find(".prev"),
        nextArrow: slickInduvidual.parent().find(".next")
      });
    });

    $(".how-works-slider").slick({prevArrow: $(".prev-works"), nextArrow: $(".next-works"), dots: false});

    $(".how-verifies-slider").slick({prevArrow: $(".prev-verifies"), nextArrow: $(".next-verifies"), dots: false});

    $(document).ready(function() {
      if ($(window).width() >= 1200) 
        $(".form-slider").css("margin-right", $(".form-wrapper").outerWidth() + "px");
       else 
        $(".form-slider").css("margin-right", 0);
      

      $('a[href="#mmenu"]').click(function() {
        $("html,body").toggleClass("noscroll");

        if ($(this).hasClass("open")) {
          $("#mobileNav").height("0");
        } else {
          $("#mobileNav").height("100%");
        }

        $("#mobileNav").css("margin-top", 70);
        $("#mobileNav .overlay-content").css("margin-bottom", 70);
        $(".overlay-content .site-nav--has-dropdown").removeClass("active");
        $(this).toggleClass("open");
      });

      fullPage("a3i", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "PPFD & Light Planning"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "efficacy-operating-costs", "Efficacy and Operating Costs"
      ], [
        "surface-temperature", "Surface Temperature"
      ], [
        "ip65-rating", "IP67 Rating"
      ], [
        "power-surges", "Power Surges"
      ], [
        "spectral-charts", "Spectral Charts"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("a3i-pro", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "PPFD & Light Planning"
      ], [
        "spectral-capabilities", "Spectral Tuning Capabilities"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "efficacy-operating-costs", "Efficacy and Operating Costs"
      ], [
        "surface-temperature", "4 in 1 Sensor"
      ],[
        "ip65-rating", "IP66 Rating & Surface Temperature"
      ], [
        "power-surges", "Power Surges"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("f1v", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "PPFD & Light Planning"
      ], [
        "multiple-configuration-spectral-output", "Multiple Configuration & Spectral Output"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "IP65 Rating"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("f1v-plus", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "PPFD & Light Planning"
      ], [
        "multiple-configuration-spectral-output", "Multiple Configuration & Spectral Output"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "IP65 Rating"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("f1v-420", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "PPFD & Light Planning"
      ], [
        "multiple-configuration-spectral-output", "Multiple Configuration & Spectral Output"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "IP65 Rating"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("f1v-600", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "PPFD & Light Planning"
      ], [
        "multiple-configuration-spectral-output", "Multiple Configuration & Spectral Output"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "IP65 Rating"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("f1v-600-plus", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "PPFD & Light Planning"
      ], [
        "multiple-configuration-spectral-output", "Multiple Configuration & Spectral Output"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "IP65 Rating"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("f1v-800", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "PPFD & Light Planning"
      ], [
        "multiple-configuration-spectral-output", "Multiple Configuration & Spectral Output"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "IP65 Rating"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("f1v-800-plus", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "PPFD & Light Planning"
      ], [
        "multiple-configuration-spectral-output", "Multiple Configuration & Spectral Output"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "IP65 Rating"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("o6i", new Array([
        "intro", "Intro"
      ], [
        "ppf-output-greenhouse-toplighting", "PPF Output, Greenhouse Toplighting"
      ], [
        "ppfd-light-planning-spectral-output-chart", "PPFD, Light Planning, Spectral Output Chart"
      ], [
        "light-harvesting-dli-planning", "Light Harvesting & DLI Planning"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "IP65 Rating"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("o6i-plus", new Array([
        "intro", "Intro"
      ], [
        "ppf-output-greenhouse-toplighting", "PPF Output, Greenhouse Toplighting"
      ], [
        "ppfd-light-planning-spectral-output-chart", "PPFD, Light Planning, Spectral Output Chart"
      ], [
        "light-harvesting-dli-planning", "Light Harvesting & DLI Planning"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "IP65 Rating"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("aries", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light", "PPFD & Light Planning"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ],

      // ["efficacy-operating-costs", "Efficacy and Operating Costs"],
      // ["surface-temperature", "Surface Temperature"],
        [
        "ip65-rating", "IP67 Rating"
      ],

      // ["power-surges", "Power Surges"],
        [
        "spectral-charts", "Spectral Charts"
      ], [
        "touchscreen-control", "Touchscreen Control"
      ], [
        "integration", "Integration"
      ], [
        "tech-specs-download", "Tech Specs Download"
      ], ["faqs", "Frequently Asked Questions"]));

      fullPage("aries-pro", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light", "PPFD & Light Planning"
      ], [
        "spectral-capabilities", "Spectral Tuning Capabilities"
      ],[
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ],
      [
        "sensor", "4 in 1 Sensor"
      ],
      [
        "ip65-rating", "IP66 Rating & Surface Temperature"
      ], [
        "integration", "Integration"
      ], [
        "tech-specs-download", "Tech Specs Download"
      ], ["faqs", "Frequently Asked Questions"]));

      fullPage("pleiades", new Array([
        "intro", "Intro"
      ], [
        "ppf-output-greenhouse-toplighting", "PPF Output, Greenhouse Toplighting"
      ], [
        "ppfd-light-planning-spectral-output-chart", "PPFD, Light Planning, Spectral Output Chart"
      ], [
        "light-harvesting-dli-planning", "Light Harvesting & DLI Planning"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "IP44 Rating"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("pleiades-plus", new Array([
        "intro", "Intro"
      ], [
        "ppf-output-greenhouse-toplighting", "PPF Output, Greenhouse Toplighting"
      ], [
        "ppfd-light-planning-spectral-output-chart", "PPFD, Light Planning, Spectral Output Chart"
      ], [
        "light-harvesting-dli-planning", "Light Harvesting & DLI Planning"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "IP44 Rating"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("sirius-dev", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "PPFD & Light Planning"
      ], [
        "dual-configuration-spectral-output", "Dual Configuration & Spectral Output"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "IP65 Rating"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("scorpio", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "PPFD & Light Planning"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "efficacy-operating-costs", "Efficacy and Operating Costs"
      ],[
        "surface-temperature", "Surface Temperature"
      ], [
        "ip65-rating", "IP67 Rating"
      ], [
        "power-surges", "Power Surges"
      ], [
        "spectral-charts", "Spectral Charts"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("scorpio-pro", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "PPFD & Light Planning"
      ], [
        "spectral-capabilities", "Spectral Tuning Capabilities"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "efficacy-operating-costs", "Efficacy and Operating Costs"
      ],[
        "surface-temperature", "4 in 1 Sensor"
      ], [
        "ip65-rating", "IP66 Rating & Surface Temperature"
      ], [
        "power-surges", "Power Surges"
      ], [
        "integration", "Integration"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("pisces", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "Form Factor & Mobility"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "multiple-configuration-spectral-output", "Spectral Distribution"
      ], [
        "integration", "Integration"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "Lensing Technology"
      ], ["tech-specs-download", "Tech Specs Download"]));
      fullPage("pisces-9", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "ppfd-light-planning", "Form Factor & Mobility"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "multiple-configuration-spectral-output", "Spectral Distribution"
      ], [
        "integration", "Integration"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip65-rating", "Lensing Technology"
      ], ["tech-specs-download", "Tech Specs Download"]));
      fullPage("pisces-7", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "light-planning", "Form Factor & Mobility"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "multiple-configuration-spectral-output", "Spectral Distribution"
      ], [
        "integration", "Integration"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip66-rating", "Lensing Technology"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("pisces-5", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "light-planning", "PPFD & Light Planning"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "multiple-configuration-spectral-output", "Multiple Configuration & Spectral Output"
      ], [
        "integration", "Integration"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip66-rating", "IP44 Rating"
      ], ["tech-specs-download", "Tech Specs Download"]));

      fullPage("pisces-3", new Array([
        "intro", "Intro"
      ], [
        "ppf-output", "PPF Output"
      ], [
        "light-planning", "PPFD & Light Planning"
      ], [
        "lifespan-longevity", "Lifespan & Longevity"
      ], [
        "multiple-configuration-spectral-output", "Multiple Configuration & Spectral Output"
      ], [
        "integration", "Integration"
      ], [
        "thermal-management", "Thermal Management"
      ], [
        "ip66-rating", "IP44 Rating"
      ], ["tech-specs-download", "Tech Specs Download"]));

      if ($(".cc-slider").length) {
        let holderInfo = $(".holder-slide-info");

        $(".cc-slider").slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: true,
          dots: false,
          infinite: true,
          mobileFirst: true,
          responsive: [
            {
              breakpoint: 1800,
              settings: {
                slidesToShow: 3,
                fade: false,
                centerMode: true
              }
            }
          ]
        });
      }

      function popups() {
        const body = document.body;
        const container = document.querySelector(".fohse-preview");

        if (container == null) 
          return;
        

        const sections = container.querySelectorAll(".inner-section");
        const popups = document.querySelectorAll(".popup-item");
        const closer = document.querySelector(".close-popup");
        const opener = "open-popup";
        const clsOpen = "popup-visible";
        const popupOpened = "opened";
        let openerButtons = [];
        let parentElements = $("html, body");
        let mainContainer = $("main");
        let scrollTop;
        let windowWidth = window.innerWidth;

        function createElements(parent, result, className) {
          [].forEach.call(parent, (el) => {
            if (el.querySelectorAll("." + className)) {
              var els = el.querySelectorAll("." + className);
              els.forEach(function(bel) {
                result.push(bel);
              });
            }
          });
        }

        // popup animation
        let flag = false;
        if ($("body").hasClass("ie")) {
          flag = true;
        }

        let chart7 = bodymovin.loadAnimation({
          container: document.querySelector(".chart7"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/chart7.json?v=1599579397",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });
        let chart8 = bodymovin.loadAnimation({
          container: document.querySelector(".chart8"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/chart8.json?v=1599579397",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });

        let a3i_chart2_tab = document.querySelector(".a3i_chart2_tab");

        let a3i_chart7_tab = document.querySelector(".a3i_chart7_tab");
        if (a3i_chart7_tab) {
          a3i_chart7_tab.addEventListener("click", function() {
            chart7.goToAndStop(1);
            setTimeout(function() {
              chart7.goToAndPlay(1);
            }, 300);
          });
        }

        let a3i_chart8_tab = document.querySelector(".a3i_chart8_tab");
        if (a3i_chart8_tab) {
          a3i_chart8_tab.addEventListener("click", function() {
            chart8.goToAndStop(1);
            setTimeout(function() {
              chart8.goToAndPlay(1);
            }, 300);
          });
        }

        let scorpio_chart7_tab = document.querySelector(".scorpio_chart7_tab");
        if (scorpio_chart7_tab) {
          scorpio_chart7_tab.addEventListener("click", function() {
            chart7.goToAndStop(1);
            setTimeout(function() {
              chart7.goToAndPlay(1);
            }, 300);
          });
        }

        let scorpio_chart8_tab = document.querySelector(".scorpio_chart8_tab");
        if (scorpio_chart8_tab) {
          scorpio_chart8_tab.addEventListener("click", function() {
            chart8.goToAndStop(1);
            setTimeout(function() {
              chart8.goToAndPlay(1);
            }, 300);
          });
        }

        let chart_the_infrared_spike = bodymovin.loadAnimation({
          container: document.querySelector(".chart_the_infrared_spike"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/the_infrared_splike.json?v=1609956308",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });

        let chart_the_infrared_spike_O6i = bodymovin.loadAnimation({
          container: document.querySelector(".chart_the_infrared_spike_O6i"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/the_infrared_splike.json?v=1609956308",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });

        let chart_the_infrared_spike_Pleiades = bodymovin.loadAnimation({
          container: document.querySelector(".chart_the_infrared_spike_Pleiades"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/pleiades_greenhouse_spectrum.json?v=1619026992",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });

        let f1v_chart2_tab = document.querySelector(".f1v_chart2_tab");
        if (f1v_chart2_tab) {
          f1v_chart2_tab.addEventListener("click", function() {
            chart_the_infrared_spike.goToAndStop(1);
            setTimeout(function() {
              chart_the_infrared_spike.goToAndPlay(1);
            }, 300);
          });
        }

        let chart_thermodynamically_balanced = bodymovin.loadAnimation({
          container: document.querySelector(".chart_thermodynamically_balanced"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/thermodinamically_balanced.json?v=1609957285",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });

        let f1v_chart7_tab = document.querySelector(".f1v_chart7_tab");
        if (f1v_chart7_tab) {
          f1v_chart7_tab.addEventListener("click", function() {
            chart7.goToAndStop(1);
            setTimeout(function() {
              chart7.goToAndPlay(1);
            }, 300);
          });
        }

        let f1v_chart8_tab = document.querySelector(".f1v_chart8_tab");
        if (f1v_chart8_tab) {
          f1v_chart8_tab.addEventListener("click", function() {
            chart_thermodynamically_balanced.goToAndStop(1);
            setTimeout(function() {
              chart_thermodynamically_balanced.goToAndPlay(1);
            }, 300);
          });
        }

        let aries_chart7_tab = document.querySelector(".aries_chart7_tab");
        if (aries_chart7_tab) {
          aries_chart7_tab.addEventListener("click", function() {
            chart7.goToAndStop(1);
            setTimeout(function() {
              chart7.goToAndPlay(1);
            }, 300);
          });
        }

        let aries_chart8_tab = document.querySelector(".aries_chart8_tab");
        if (aries_chart8_tab) {
          aries_chart8_tab.addEventListener("click", function() {
            chart8.goToAndStop(1);
            setTimeout(function() {
              chart8.goToAndPlay(1);
            }, 300);
          });
        }

        let a3i_chart_lifespan = bodymovin.loadAnimation({
          container: document.querySelector(".a3i_chart_lifespan"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/graph_08_3.json",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });

        let scorpio_chart_lifespan = bodymovin.loadAnimation({
          container: document.querySelector(".scorpio_chart_lifespan"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/scorpio_lifespan_logetivity.json?v=1625617353",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });

        let f1v_chart_lifespan = bodymovin.loadAnimation({
          container: document.querySelector(".f1v_chart_lifespan"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/graph_f1v_lifespan_new.json",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });

        let aries_chart_lifespan = bodymovin.loadAnimation({
          container: document.querySelector(".aries_chart_lifespan"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/graph_aries_lifespan.json",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });

        let o6i_chart_lifespan = bodymovin.loadAnimation({
          container: document.querySelector(".o6i_chart_lifespan"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/graph_o6i_lifespan.json",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });

        let pleiades_chart_lifespan = bodymovin.loadAnimation({
          container: document.querySelector(".pleiades_chart_lifespan"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/pleiades_lifespan.json",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });

        let chart_pleiades_greenhouse_spectrum = bodymovin.loadAnimation({
          container: document.querySelector(".chart_pleiades_greenhouse_spectrum"),
          renderer: "svg",
          loop: false,
          autoplay: flag,
          path: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/pleiades_greenhouse_spectrum.json",
          assetsPath: "https://cdn.shopify.com/s/files/1/0261/7910/8911/files/"
        });

        let pleiades_chart_pleiades_greenhouse_spectrum_tab = document.querySelector(".pleiades_chart_pleiades_greenhouse_spectrum_tab");
        if (pleiades_chart_pleiades_greenhouse_spectrum_tab) {
          pleiades_chart_pleiades_greenhouse_spectrum_tab.addEventListener("click", function() {
            chart_pleiades_greenhouse_spectrum.goToAndStop(1);
            setTimeout(function() {
              chart_pleiades_greenhouse_spectrum.goToAndPlay(1);
            }, 300);
          });
        }

        let pleiades_chart_chart_thermodynamically_balanced_tab = document.querySelector(".pleiades_chart_chart_thermodynamically_balanced_tab");
        if (pleiades_chart_chart_thermodynamically_balanced_tab) {
          pleiades_chart_chart_thermodynamically_balanced_tab.addEventListener("click", function() {
            chart_thermodynamically_balanced.goToAndStop(1);
            setTimeout(function() {
              chart_thermodynamically_balanced.goToAndPlay(1);
            }, 300);
          });
        }

        createElements(sections, openerButtons, opener);
        openerButtons.forEach((el, index) => {
          el.addEventListener("click", (e) => {

            /*if (windowWidth < 1200) {
            lockBody();
            }*/
            $.scrollify.disable();
            body.classList.add(clsOpen);
            closer.classList.add("active");
            popups[index].classList.add(popupOpened);
            if (!$("body").hasClass("ie")) {
              if (document.querySelector('.page-holder.a3i')) {
                console.log(index)
                if (index === 6) {
                  a3i_chart_lifespan.goToAndStop(1);
                  setTimeout(function() {
                    a3i_chart_lifespan.goToAndPlay(1);
                  }, 700);
                }
                if (index === 6) {
                  a3i_chart7_tab.click();
                }
                if (index === 7) {
                  $(".a3i_steps_tab_1").click();
                }
                if (index === 8) {
                  a3i_chart2_tab.click();
                }
              }  else if(document.querySelector('.page-holder.a3i-pro')){
                console.log(index)
                if (index === 6) {
                  a3i_chart_lifespan.goToAndStop(1);
                  setTimeout(function() {
                    a3i_chart_lifespan.goToAndPlay(1);
                  }, 700);
                }
                if (index === 5) {
                  a3i_chart7_tab.click();
                }
                if (index === 8) {
                  $(".a3i_steps_tab_1").click();
                }
                if (index === 7) {
                  a3i_chart2_tab.click();
                }
              }
              else if ($("main > .page-holder").hasClass("f1v") || $("main > .page-holder").hasClass("f1v-plus") || $("main > .page-holder").hasClass("f1v-800") || $("main > .page-holder").hasClass("f1v-800-plus") || $("main > .page-holder").hasClass("f1v-600") || $("main > .page-holder").hasClass("f1v-600-plus") || $("main > .page-holder").hasClass("f1v-420")) {
                if (index === 5) {
                  f1v_chart2_tab.click();
                }
                if (index === 6) {
                  f1v_chart_lifespan.goToAndStop(1);
                  setTimeout(function() {
                    f1v_chart_lifespan.goToAndPlay(1);
                  }, 700);
                }
                if (index === 7) {
                  f1v_chart7_tab.click();
                }
              } else if (document.querySelector('.page-holder.aries')) {
                if (index === 4) {
                  aries_chart_lifespan.goToAndStop(1);
                  setTimeout(function() {
                    aries_chart_lifespan.goToAndPlay(1);
                  }, 700);
                }
                if (index === 5) {
                  aries_chart7_tab.click();
                }
                if (index === 6) {
                  a3i_chart2_tab.click();
                }
                if (index === 7) {

                  a3i_chart2_tab.click();
                }
              }else if (document.querySelector('.page-holder.aries-pro')) {
                if (index === 6) {
                  aries_chart_lifespan.goToAndStop(1);
                  setTimeout(function() {
                    aries_chart_lifespan.goToAndPlay(1);
                  }, 700);
                }
                if (index === 7) {
                  aries_chart7_tab.click();
                }
                if (index === 8) {
                  a3i_chart2_tab.click();
                }
              } else if ($("main > .page-holder").hasClass("o6i") || $("main > .page-holder").hasClass("o6i-plus")) {
                if (index === 3) {
                  chart_the_infrared_spike_O6i.goToAndStop(1);
                  setTimeout(function() {
                    chart_the_infrared_spike_O6i.goToAndPlay(1);
                  }, 700);
                }
                if (index === 6) {
                  o6i_chart_lifespan.goToAndStop(1);
                  setTimeout(function() {
                    o6i_chart_lifespan.goToAndPlay(1);
                  }, 700);
                }
                if (index === 7) {
                  f1v_chart2_tab.click();
                }
              } else if ($("main > .page-holder").hasClass("pleiades") || $("main > .page-holder").hasClass("pleiades-plus")) {
                if (index === 3) {
                  chart_the_infrared_spike_Pleiades.goToAndStop(1);
                  setTimeout(function() {
                    chart_the_infrared_spike_Pleiades.goToAndPlay(1);
                  }, 700);
                }
                if (index === 5) {
                  pleiades_chart_lifespan.goToAndStop(1);
                  setTimeout(function() {
                    pleiades_chart_lifespan.goToAndPlay(1);
                  }, 700);
                }
                if (index === 6) {
                  pleiades_chart_pleiades_greenhouse_spectrum_tab.click();
                }
              } else if (document.querySelector('.page-holder.scorpio')) {
                if (index === 4) {
                  scorpio_chart_lifespan.goToAndStop(1);
                  setTimeout(function() {
                    scorpio_chart_lifespan.goToAndPlay(1);
                  }, 700);
                }
                if (index === 5) {
                  scorpio_chart7_tab.click();
                }
                if (index === 6) {
                  a3i_chart2_tab.click();
                }
              } else if ( document.querySelector('.page-holder.scorpio-pro')) {
                console.log('index',index)
                if (index === 5) {
                  scorpio_chart_lifespan.goToAndStop(1);
                  setTimeout(function() {
                    scorpio_chart_lifespan.goToAndPlay(1);
                  }, 700);
                }
                if (index === 6) {
                  scorpio_chart7_tab.click();
                }
                if (index === 4) {
                  a3i_chart2_tab.click();
                }
              }else if ($("main > .page-holder").hasClass("pisces") || $("main > .page-holder").hasClass("pisces-9") || $("main > .page-holder").hasClass("pisces-7") || $("main > .page-holder").hasClass("pisces-5") || $("main > .page-holder").hasClass("pisces-3")) {
                if (index === 4) {
                  f1v_chart_lifespan.goToAndStop(1);
                  setTimeout(function() {
                    f1v_chart_lifespan.goToAndPlay(1);
                  }, 700);
                }
                if (index === 5) {
                  f1v_chart7_tab.click();
                }
              } else {}
            }

            e.preventDefault();
          });
        });

        closer.addEventListener("click", (e) => {
          closer.classList.remove("active");

          /*if (windowWidth < 1200) {
          unlockBody();
          }*/
          [].forEach.call(popups, (item) => {
            if (item.classList.contains(popupOpened)) {
              item.classList.remove(popupOpened);
            }
          });
          $.scrollify.enable();
          setTimeout(function() {
            body.classList.remove(clsOpen);
          }, 800);

          e.preventDefault();
        });

        document.addEventListener("keydown", function(e) {
          if (e.keyCode == 27 && $(".close-popup").hasClass("active")) {
            closer.classList.remove("active");

            /*if (windowWidth < 1200) {
            unlockBody();
            }*/
            [].forEach.call(popups, (item) => {
              if (item.classList.contains(popupOpened)) {
                item.classList.remove(popupOpened);
              }
            });
            $.scrollify.enable();
            setTimeout(function() {
              body.classList.remove(clsOpen);
            }, 800);

            e.preventDefault();
          }
        });

        $(".popup-item").on("click", function(e) {
          if (e.target !== this) 
            return;
          

          closer.classList.remove("active");

          /*if (windowWidth < 1200) {
          unlockBody();
          }*/
          [].forEach.call(popups, (item) => {
            if (item.classList.contains(popupOpened)) {
              item.classList.remove(popupOpened);
            }
          });
          $.scrollify.enable();
          setTimeout(function() {
            body.classList.remove(clsOpen);
          }, 800);

          e.preventDefault();
        });
        $(".popup-item-badge").on("click", function(e) {
          if (e.target !== this) 
            return;
          

          closer.classList.remove("active");

          /*if (windowWidth < 1200) {
          unlockBody();
          }*/
          [].forEach.call(popups, (item) => {
            if (item.classList.contains(popupOpened)) {
              item.classList.remove(popupOpened);
            }
          });
          $.scrollify.enable();
          setTimeout(function() {
            body.classList.remove(clsOpen);
          }, 800);

          e.preventDefault();
        });
      }

      $(window).on("load", function() {
        if (location.hash && $(location.hash.substr(0).split("?", 1)[0]).offset()) 
          $("html, body").animate({
            scrollTop: $(location.hash.substr(0).split("?", 1)[0]).offset().top - 120
          }, "linear");
        
      });

      $('a[href*="#"]:not([href="#"])').click(function(e) {
        if ($(this).hasClass("nav-icon")) 
          return;
        

        if ($(this).closest("ul").attr("id") == "fullpageMenu") 
          return;
        

        e.preventDefault();

        $("html, body").stop().animate({
          scrollTop: $(this.hash).offset().top - 120
        }, "linear");
      });

      if ($(".inner-section .button.start-popup").length) {
        popups();
      }

      $("a.add-to-cart").click(function(event) {
        event.preventDefault();
        var variantId = $(this).data("id");

        // jQuery.post('/cart/add.js', {
        // items: [
        //     {
        //       'quantity': 1,
        //       'id': variantId
        //     }
        // ]
        // });

        $.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: "quantity=" + 1 + "&id=" + variantId,
          dataType: "json",
          success: function(response) {
            $.ajax({
              type: "GET",
              url: "/cart?view=ajax",
              dataType: "html",
              success: function(cartdata) {
                $(".cart-popup .cart-item-popup").html(cartdata);
                $(".cart-popup").addClass("is_active");
                add_item_cart_incre_decre();
              }
            });
          }
        });
      });

      $(".collapsible").click(function() {
        $(this).toggleClass("active");

        var content = $(this).next().get(0);

        if (content.style.maxHeight) 
          content.style.maxHeight = null;
         else 
          content.style.maxHeight = content.scrollHeight + "px";
        
      });

      $(".a3i_steps").click(function() {
        var idx = $(this).index();
        $(".tabs-wrap.less-margin .comparisons .tab").removeClass("animated");
        setTimeout(function() {
          $(".tabs-wrap.less-margin .comparisons .tab").eq(idx).addClass("animated");
          $(".comparisons .tab .lines").css("width", (idx + 1) * 10 + "%");
        }, 100);
      });

      $("select.tabs-nav").change(function(e) {
        e.preventDefault();
        var idx = $(this).prop("selectedIndex");
        $(".tabs-wrap.less-margin .comparisons .tab").removeClass("animated").removeClass("active");
        $(".tabs-wrap.less-margin .comparisons .tab").eq(idx).addClass("active");
        setTimeout(function() {
          $(".tabs-wrap.less-margin .comparisons .tab").eq(idx).addClass("animated");
          $(".comparisons .tab .lines").css("width", (idx + 1) * 10 + "%");
        }, 100);
      });

      $(".cart-item-popup-close span").click(function() {
        $(".cart-popup").removeClass("is_active");
      });

      function add_item_cart_incre_decre() {
        $(".cart-popup .cart__quantity-td .cart__qty a.cart__qty_increment").click(function(event) {
          event.preventDefault();
          variantId = $(this).data("id");
          $.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: "quantity=" + 1 + "&id=" + variantId,
            dataType: "json",
            success: function(response) {
              $.ajax({
                type: "GET",
                url: "/cart?view=ajax",
                dataType: "html",
                success: function(cartdata) {
                  $(".cart-popup .cart-item-popup").html(cartdata);
                  add_item_cart_incre_decre();
                }
              });
            }
          });
        });
        $(".cart-popup .cart__quantity-td .cart__qty a.cart__qty_decrement").click(function(event) {
          event.preventDefault();
          variantId = variantId = $(this).data("id");
          var item_number = parseInt($(this).siblings("input").val());
          $.ajax({
            type: "POST",
            url: "/cart/update.js",
            data: "updates[" + variantId + "]=" + item_number + "&updates[" + variantId + "]=" + (
              item_number - 1
            ),
            dataType: "json",
            success: function(response) {
              $.ajax({
                type: "GET",
                url: "/cart?view=ajax",
                dataType: "html",
                success: function(cartdata) {
                  $(".cart-popup .cart-item-popup").html(cartdata);
                  add_item_cart_incre_decre();
                }
              });
            }
          });
        });
      }

      $(".contact_us .contact-form .large-holder .list-item").click(function() {
        $(this).find("input").click();
      });
      if ($(".contact_us").length) {
        $(".header > a").css("display", "none");
      }

      $(".open-simple-popup").click(function(e) {
        e.preventDefault();
        var $sp = $(this).closest(".slide-template").find(".simple-popup");

        $sp.addClass("open");
        setTimeout(function() {
          $sp.removeClass("open");
        }, 2000);
      });

      $("#shopify-section-home-growers-slider .growers-logos .grower-logo").click(function(e) {
        if (!$(this).hasClass("show-data")) {
          $(".growers-logos .grower-logo .data").empty();
          $(".growers-logos .grower-logo").removeClass("show-data");

          if ($(this).hasClass("active")) {
            $(this).removeClass("active");

            $(".growers-gallery").slideUp(function() {
              $(this).slick("slickUnfilter");
            });
          } else {
            $(".growers-logos .grower-logo").not(this).removeClass("active");
            var $this = this;

            var lbs = $(this).data("lbs");
            var g = $(this).data("g");
            var case_study = $(this).data("case");

            var idx = $(this).index();
            var count = $(".growers-logos .grower-logo").length;

            var idx_lbs = idx + 1;
            var idx_g = idx + 2;
            var idx_case_study = idx + 3;

            var space_available = Math.abs(count - (idx + 1));

            if (space_available == 2) {
              idx_lbs = idx - 1;
              idx_g = idx + 1;
              idx_case_study = idx + 2;
            } else if (space_available == 1) {
              idx_lbs = idx - 2;
              idx_g = idx - 1;
              idx_case_study = idx + 1;
            } else if (space_available == 0) {
              idx_lbs = idx - 3;
              idx_g = idx - 2;
              idx_case_study = idx - 1;
            }

            $(".growers-gallery").fadeOut(50, function() {
              $(".growers-gallery").slick("slickUnfilter");
              $(".growers-gallery").slick("slickFilter", "." + $($this).data("grower"));
              $(".growers-gallery").slideDown();
              $($this).addClass("active");

              if (lbs) 
                $(".growers-logos .grower-logo")
                  .eq(idx_lbs)
                  .addClass("show-data")
                  .find(".data")
                  .html('<div class="number h1">' + lbs + "<span>lbs/sqft</span></div>");
              

              if (g) 
                $(".growers-logos .grower-logo")
                  .eq(idx_g)
                  .addClass("show-data")
                  .find(".data")
                  .html('<div class="number h1">' + g + "<span>g/sqft</span></div>");
              

              if (case_study) 
                $(".growers-logos .grower-logo")
                  .eq(idx_case_study)
                  .addClass("show-data")
                  .find(".data")
                  .html('<div class="number"><a target="_blank" href="' + case_study + '">View the case study +</a></div>');
              
            });
          }
        } else {
          if ($(this).find("a").length) 
            window.location.href = $(this).find("a").attr("href");
          
        }
      });

      $(".popup-video").magnificPopup({
        disableOn: 700,
        type: "iframe",
        mainClass: "mfp-fade",
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false
      });

      $(".testimonials-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        autoplay: true,
        rows: 0,
        cssEase: "linear",
        infinite: true,
        arrows: false,
        dots: true,
        customPaging: function(slick, index) {
          return "<a> " + index + "</a>";
        },
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }, {
            breakpoint: 768,
            settings: {
              autoplaySpeed: 1500
            }
          }, {
            breakpoint: 568,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });

      $(".overlay-content .site-nav--has-dropdown").click(function(e) {
        e.preventDefault();
        $(this).siblings().removeClass("active");
        $(this).toggleClass("active");
      });

      $(".overlay-content").click(function(e) {
        if (!$(e.target).is(".site-mobile-nav *")) 
          $(".site-nav--has-dropdown").removeClass("active");
        
      });

      $(".site-nav .site-nav--has-dropdown").hover(function() {
        $(this).addClass("active");
      }, function() {
        $(this).removeClass("active");
      });

      $(".products-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 0,
        cssEase: "linear",
        infinite: true,
        arrows: true,
        dots: false,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve"><polygon points="315.869,21.178 294.621,0 91.566,203.718 294.621,407.436 315.869,386.258 133.924,203.718"></polygon></svg></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Previous" type="button" style=""><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve"><polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718"></polygon></svg></button>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              autoplay: true,
              autoplaySpeed: 1500
            }
          }
        ]
      });

      $(".products-slider-n").slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        rows: 0,
        dots: true,
        focusOnSelect: true,
        centerMode: false,
        asNavFor: ".products-slider",
        centerPadding: "0",
        customPaging: function(slick, index) {
          return "<a> " + index + "</a>";
        },
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 3
            }
          }, {
            breakpoint: 568,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          }
        ]
      });

      $("#shopify-section-home-slider-form .form-slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 0,
        cssEase: "linear",
        infinite: true,
        arrows: false,
        dots: true,
        customPaging: function(slick, index) {
          return "<a> " + index + "</a>";
        },
        accessibility: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              autoplay: true,
              autoplaySpeed: 1500
            }
          }
        ]
      });

      $("#shopify-section-home-growers-slider .growers-gallery").slick({
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        rows: 0,
        arrows: false,
        infinite: true,
        cssEase: "linear",
        variableWidth: true,
        variableHeight: true,
        customPaging: function(slick, index) {
          return "<a> " + index + "</a>";
        },
        accessibility: false
      });

      $("#shopify-section-home-growers-slider .growers-gallery").slickLightbox({
        src: "src",
        itemSelector: ".slide:not(.slick-clone) img",
        slick: {
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve"><polygon points="315.869,21.178 294.621,0 91.566,203.718 294.621,407.436 315.869,386.258 133.924,203.718"></polygon></svg></button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve"><polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718"></polygon></svg></button>'
        }
      });

      $('[id^="shopify-section-case-study-info"] .growers-gallery').slick({
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        rows: 0,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        cssEase: "linear",
        variableWidth: true,
        variableHeight: true,
        customPaging: function(slick, index) {
          return "<a> " + index + "</a>";
        }
      });

      $('[id^="shopify-section-case-study-info"] .growers-gallery').slickLightbox({
        src: "src",
        itemSelector: ".slide:not(.slick-clone) img",
        slick: {
          prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve"><polygon points="315.869,21.178 294.621,0 91.566,203.718 294.621,407.436 315.869,386.258 133.924,203.718"></polygon></svg></button>',
          nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 407.436 407.436" style="enable-background:new 0 0 407.436 407.436;" xml:space="preserve"><polygon points="112.814,0 91.566,21.178 273.512,203.718 91.566,386.258 112.814,407.436 315.869,203.718"></polygon></svg></button>'
        }
      });

      $(".open-popup-link").magnificPopup({type: "inline", midClick: true, mainClass: "mfp-fade"});
    });

    function openTab(evt, tabName) {
      var i,
        tabcontent,
        tablinks;
      tabcontent = document.getElementsByClassName("tabcontent");
      for (i = 0; i < tabcontent.length; i++) {
        tabcontent[i].style.display = "none";
      }
      tablinks = document.getElementsByClassName("tablinks");
      for (i = 0; i < tablinks.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" active", "");
      }
      document.getElementById(tabName).style.display = "block";
      evt.currentTarget.className += " active";
    }

    $(window).on("load", function() {
      $(window).scroll(function() {
        var windowBottom = $(this).scrollTop() + $(this).innerHeight();
        $(".fade").each(function() {

          /* Check the location of each desired element */
          var objectBottom = $(this).offset().top + $(this).outerHeight();

          /* If the element is completely within bounds of the window, fade it in */
          if (objectBottom < windowBottom) { // object comes into view (scrolling down)
            $(this).addClass("visible");
          }
        });
      }).scroll(); // invoke scroll-handler on page-load
    });

    $(function() {
      if ($(".custom-select").length) {
        jcf.setOptions("Select", {
          wrapNative: false,
          fakeDropInBody: false,
          wrapNativeOnMobile: false,
          flipDropToFit: false,
          maxVisibleItems: 4
        });
        jcf.replace($(".custom-select"));

        // jcf.replaceAll($("select"));
      }
    });

    let int4 = setInterval(cartUpdate, 1000);

    function cartUpdate() {
      const minicartWrapper = document.querySelector(".minicart-product__quantity");
      if (! minicartWrapper) {
        return;
      }

      // buy block pdp

      const increase = minicartWrapper.querySelector(".increase");
      const reduce = minicartWrapper.querySelector(".reduce");

      const numberValue = minicartWrapper.querySelector(".minicart-product__quantity-input");

      const hiddenInput = document.querySelector(".number-input");

      const addToCartBtn = document.querySelector(".submit-btn");

      const selectedVariantId = document.querySelector(".selected-variant-id");

      const optionTogglers = document.querySelectorAll(".option_toggler");

      let optionTogglerActive = document.querySelector(".option_toggler.active .hidden");

      let prices = document.querySelectorAll(".product-price");

      let jcfSelect = document.querySelector(".jcf-select");

      const readMore = document.querySelector(".read-more-btn");
      const productDescriptionFull = document.querySelector(".product-description-full");
      const productDescription = document.querySelector(".product-description");

      const mainSelect = document.getElementById("mainSelect");

      addToCartBtn.addEventListener("click", function() {
        e.preventDefault();
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(
            {quantity: hiddenInput.value, id: selectedVariantId.dataset.variantId}
          )
        });
      });

      readMore.addEventListener("click", function() {
        productDescriptionFull.classList.remove("hidden");
        productDescription.classList.add("hidden");
        readMore.classList.add("hidden");
      });

      // optionTogglers.forEach((option) => {
      // option.addEventListener("click", (e) => {
      //     optionTogglers.forEach((toggler) => toggler.classList.remove("active"));
      //     e.target.classList.add("active");
      //     let optionTogglerActive = document.querySelector(
      //       ".option_toggler.active .hidden"
      //     );
      //     console.log(optionTogglerActive);
      //     // let wattOptionSelected = document.querySelector(".jcf-select-text span");
      //     changeSelect(optionTogglerActive.innerText, wattOptionSelected.innerText);
      // });
      // });

      increase.addEventListener("click", function(e) {
        e.preventDefault();
        numberValue.value = + numberValue.value + 1;
        hiddenInput.value = numberValue.value;
      });
      reduce.addEventListener("click", function(e) {
        e.preventDefault();
        if (numberValue.value == 1) 
          return;
        
        numberValue.value = + numberValue.value - 1;
        hiddenInput.value = numberValue.value;
      });

      let selectInterval = setInterval(() => {
        let jcfSelect = document.querySelector(".jcf-select");
        if (jcfSelect) {
          addSelectEvent();
          clearInterval(selectInterval);
        }
      }, 100);

      function addSelectEvent(params) {
        jcfSelect.addEventListener("click", function(e) {
          setTimeout(() => {
            let li = document.querySelectorAll(".jcf-select-drop .jcf-option");
            li.forEach((item) => {
              item.addEventListener("click", (e) => {
                changeSelect(e.target.innerText.trim());
              });
            });
          }, 200);
        });
      }

      function changeSelect(select) {
        prices.forEach((toggler) => toggler.classList.remove("active"));
        prices.forEach((toggler) => {
          if (toggler.dataset.title == select) {
            toggler.classList.add("active");
          }
        });
        let mainSelectOptions = mainSelect.querySelectorAll("option");
        mainSelectOptions.forEach((option) => {
          if (option.dataset.title == select) {
            selectedVariantId.dataset.variantId = option.value;
            mainSelect.value = option.value;
          }
        });

        // mainSelect.value = foundItem.value;
        return;

        // let checkValue = `${toggle} / ${select}`;

        let foundItem = Array.from(mainSelect.options).find((item) => item.dataset.title.toUpperCase() === checkValue.toUpperCase());
        let foundPrice = Array.from(prices).find((item) => item.dataset.title.toUpperCase() === checkValue.toUpperCase());

        prices.forEach((toggler) => toggler.classList.remove("active"));
        prices.forEach((toggler) => toggler.classList.remove("active"));

        foundPrice.classList.add("active");
      }
      clearInterval(int4);

      function addToCart(params) {
        e.preventDefault();
        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(
            {quantity: hiddenInput.value, id: selectedVariantId.dataset.variantId}
          )
        });
      }
    }